module.exports = __webpack_public_path__ + "img/leem.6ca524e7.jpg";